/* globals Class, jui, lp,  LP, gon */
var jQuery = require('jquery');
var _ = require('lodash');

var ubBanzai = require('ub/control/banzai-features');
var getLightboxInsertion = require('ub/publish/lightbox-insertions').default;
var contentTypeConfig = require('ub/content-type-config');
var ctaLinkFilter = require('ub/data/filters/cta-link');
var fontService = require('ub/fonts/font-service/publisher').default;
var formPublishStyles = require('ub/elements/form/publish-styles').default;

var getUnsplashTrackingPixel = require('ub/elements/image/unsplash').getUnsplashTrackingPixel;

var HIGHEST_INSERTION_PRIORITY = 1;
var LOWEST_INSTERTION_PRIORITY = 10;

var _checkCurrentVersion = function(jso, version) {
  if (jso.version && jso.version !== version) {
    throw new LP.POMError(LP.PAGE_VERSION_NEWER_ERR, '(page version is' + jso.version + ' version ' + version + 'expected)');
    // throw "Incorrect page version "+jso.version+" Current version is "+this.version;
  }
};

var defaultSettings = {
  defaultWidth                      : 760,
  showPageTransformBox              : true,
  showSectionBoundaries             : true,
  showPageSectionProtrusionWarnings : true,
  // TODO: multipleBreakpointsEnabled seems to be unused - can we remove it from defaults?
  multipleBreakpointsEnabled        : false,
  contentType                       : 'pageVariant',
};

window.lp.pom.Page = Class.create( jui.EventSource, {
  version: '3.1',
  type: 'lp-pom-page',

  initialize: function(jso, context, previewURL){
    /* jshint maxcomplexity:12 */
    _checkCurrentVersion(jso, this.version);

    this.settings = _.merge({}, defaultSettings, jso.settings);
    this.settings.activeGoals = this.settings.activeGoals || [];
    this.settings.builderVersion = window.builderVersion;

    if (ubBanzai.getFeatureValue('contentTypeOverride')) {
      this.settings.contentType = ubBanzai.getFeatureValue('contentTypeOverride');
    }

    this.bodyElement      = null;
    this.context          = context; // EDIT || PREVIEW || PUBLISH
    this.previewURL       = previewURL;
    this.page             = jso.page;
    this.name             = jso.name;
    this.title            = jso.title || '';
    this.resourceType     = jso.type || 'PageVariant';
    this.shared           = jso.shared;
    this.variant_id       = jso.variant_id || 'a';
    this.has_form         = Boolean(jso.has_form);
    this.insertions       = [];
    this.model            = this;
    this.uuid             = jso.page.uuid;
    this.wordpressEnabled = jso.wordpress_enabled;

    if (ubBanzai.features.isRunFontStorageUpgraderEnabled()) {
      this.fonts = jso.fonts;
    }

    this._setId(jso);

    this.maxDefault = 10000;
    this.minDefault = 16;

    this.undoManager = this._getUndoManager();

    this.metaData = {
      type: 'lp-pom-page-meta-data',
      name:'SEO',
      title: jso.title || '',
      description: jso.description || '',
      keywords: jso.keywords || ''
    };

    this.last_element_id = jso.last_element_id || 0;

    this.page.path_name = this._getPathName();

    this.breakpoints = [
      {name:'desktop', default:true},
      {
        name:'mobile',
        width:600,
        minPageWidth:320,
        maxPageWidth:320,
        maxPageWidthConfirmation: 240,
        minPageWidthConfirmation: 240,
      }
    ];

    this.currentBreakpoint = this.breakpoints.find(this._defaultBreakCheck, this);

    this.styles = [];
    this.elements = jso.elements;

    this.style = new lp.pom.PageStyle(this);
    this.goals = new lp.pom.PageGoals(this);
    if ( ! _.isEmpty(jso.goal_type)) { // jscs:ignore disallowSpacesInsideParentheses
      this.goals.addActiveGoal({type:jso.goal_type, url:jso.goal_url});
    }

    this.pomReady = false;
    this.buildPOM();

    this.fixHasForm();
  },

  _defaultBreakCheck: function (breakpoint) {
    return breakpoint.name === this.getConfigValue('startingBreakpoint');
  },

  _getUndoManager: function() {
    // TODO: When we remove the feature flag, refactor to only create an undo manager
    // while in edit mode
    if (ubBanzai.features.isUseEditorUndoStackEnabled() && window.editor) {
      return window.editor.undoManager;
    } else {
      return new jui.UndoManager();
    }
  },

  _setId: function(jso) {
    // Ref IDs are used within the builder to uniquely identify and reference subpages
    // within the current variant. They are separate from the page.id property, which is
    // used solely by the webapp and only populated after the first save.
    if ( ! this.settings.refId) {
      this.settings.refId = this._generateRefId();
    }

    // If the page doesn't have a webapp ID yet, give it a temporary ID based on the
    // refId. After the next save, this value will be replaced by the real webapp
    // ID.
    this.id = jso.id || 'temp_id_' + this.getRefId();
  },

  // highest priority for script insertion order
  getHighestPriority: function() {
    return HIGHEST_INSERTION_PRIORITY;
  },

  // lowest priority for script insertion order
  getLowestPriority: function() {
    return LOWEST_INSTERTION_PRIORITY;
  },

  getRefId: function() {
    return this.settings.refId;
  },

  getMainPageVariantId: function() {
    if ( ! this.isMain() && this.settings && this.settings.mainPage) {
      return this.settings.mainPage.variant_id || this.variant_id;
    } else {
      return this.variant_id;
    }
  },

  getMainPageUUID: function() {
    if ( ! this.isMain() && this.settings && this.settings.mainPage) {
      return this.settings.mainPage.uuid || this.page.uuid;
    } else {
      return this.page.uuid;
    }
  },

  _generateRefId: function() {
    if (window.editor) {
      var lastId = _(window.editor.pages)
        .map(function(page) {
          return page.getRefId();
        })
        .sortBy()
        .last() || 0;
      return lastId + 1;
    }
  },

  _getPathName: function() {
    if (this.page.path_name) {
      return this.page.path_name;
    } else if (this.isFormConfirmation()) {
      return this.getMainPageVariantId() + '-form_confirmation.html';
    } else if (this.isLightbox()) {
      return this.getMainPageVariantId() + '-' + this.getRefId() + '-lightbox.html';
    }
  },

  removeAbandonedDetachedElements: function() {
    var doElementDelete = ubBanzai.features.isRemoveDetachedElementsEnabled();
    var doDryRun = ubBanzai.features.isRemoveDetachedElementsDryRunEnabled();

    if (doDryRun || doElementDelete) {
      //Generate a list of visible elements that have been detached.
      var detachedElements = _.filter(this.elements, function(el){
        return  (typeof el.existsOnDocument === 'function' && ! el.existsOnDocument());
      });

      var listOfElementsToDelete = [];

      _.each(detachedElements, function(el) {
        //Generate a list of elements that should be removed so that we can log
        //them sentry
        listOfElementsToDelete.push(el.id);

        if (doElementDelete) {
          //Remove the elements from the page
          this.removeElement(el);
        }
      }, this);

      //If we have a list of elements to remove then log them.
      if( ! _.isEmpty(listOfElementsToDelete)) {
        var idListString = listOfElementsToDelete.join(', ');
        console.log(idListString + ' To be removed');
        var type = doElementDelete ? '[ELEMENT DELETE]' : '[LOG ONLY]';
        lp.errorNotifier.captureMessage(type + ' Detected detached visible elements on page load', {
          extra: {
            details: idListString + ' will be removed.'
          }
        });
      }
    }
  },

  fixHasForm: function() {
    // See PB-762. At least one customer page had a form but had page.has_form set to
    // false. If that's the case, correct the flag and log to Sentry.
    var realHasForm = this.getElementsByType('lp-pom-form').length > 0;
    var hasForm     = this.has_form;

    if (hasForm !== realHasForm) {
      this.has_form = realHasForm;
      lp.errorNotifier.captureMessage('Invalid page.has_form flag detected and fixed', {
        extra: {
          details: "Should have been '" + realHasForm + "', was previously set to '" +
            hasForm + "'"
        }
      });
      if (ubBanzai.features.isDebugModeEnabled()) {
        console.warn('Invalid page.has_form flag detected and fixed');
      }
    }
  },

  elementsAsJSO: function(){
    return _.map(this.elements, function(el){
      return el.toJSO();
    });
  },

  buildPOM: function() {
    var buildPageElements = function(p){
      p.elements = ( p.elements.collect( function(e) {
        var module = lp.getModule(e.type);
        if (!Object.isUndefined(module)) {
          return module.buildPageElement(p, e);
        }
        return null;
      })).compact();
    };

    var buildPageDocTree = function(p) {
      //JS: iterate through all the page elements and insert them into any containers
      p.elements.each(function(e){
        var container = p.getElementById(e.containerId);
        if( container ){
          container.insertChildElement(e);
        }
      });
    };

    buildPageElements(this);
    buildPageDocTree(this);
    this.pomReady = true;
    this.fireEvent('POMReady');
  },

  allowViewportMetaTag: function() {
    return this.isMobileEnabled() || !!this.settings.mobilePage;
  },

  isBreakpointEnabled: function(breakpointName) {
    if (breakpointName === 'mobile') {
      return Boolean(this.settings.multipleBreakpointsVisibility);
    } else if (breakpointName === 'desktop') {
      return !Boolean(this.settings.desktopBreakpointDisabled);
    } else {
      return false;
    }
  },

  isMobileEnabled: function() {
    return this.isBreakpointEnabled('mobile');
  },

  isDesktopEnabled: function() {
    return this.isBreakpointEnabled('desktop');
  },

  setBreakpointEnabled: function(breakpointName, enabled) {
    if (breakpointName === 'mobile') {
      this.settings.multipleBreakpointsVisibility = enabled;
    } else if (breakpointName === 'desktop') {
      this.settings.desktopBreakpointDisabled = !enabled;
    }
  },

  getMobileBreakpointWidth: function() {
    // On Convertable content types, we want to show the mobile version if the viewport (iframe) is
    // any narrower than the width of the desktop version, instead of using the fixed 600px
    // breakpoint value used by landing pages.
    return this.getConfigValue('useDesktopWidthAsCSSBreakpoint') ?
      this.getDimensions('desktop').width - 1 :
      this.getBreakpointByName('mobile').width;
  },

  insertPage: function(container) {
    var root = this.getRootElement();
    container.insert(root.view.e);
    if (this.isPublishOrPreviewMode()) {
      if (!!this.settings.noRobots) {
        this.insertNoRobots();
      }

      if(this.allowViewportMetaTag()) {
        this.insertViewportMetaTag();
      }
    }

    root._attach(); // if this is an _ method, why is it being called here?
    this.fireEvent('pageInserted');
    this.style.updatePageStyles();
  },

  isEditMode: function() {
    return this.context === lp.pom.context.EDIT;
  },

  isPreviewMode: function() {
    return this.context === lp.pom.context.PREVIEW;
  },

  isPublishMode: function() {
    return this.context === lp.pom.context.PUBLISH;
  },

  isPublishOrPreviewMode: function() {
    return this.isPublishMode() || this.isPreviewMode();
  },

  insertPublishedPage: function(container) {
    var root = this.getRootElement();
    container.insert(root.view.e);

    if (!!this.settings.noRobots || this.isLightbox() ) {
      this.insertNoRobots();
    }

    if(this.allowViewportMetaTag()) {
      this.insertViewportMetaTag();
    }

    this.getBreakPoints().each( function(breakpoint) {
      this.switchToBreakpoint(breakpoint.name);
      root._attach();
    }, this);

    this.fireEvent('pageInserted');
    this.style.updatePageStyles();
  },

  getMaxWidthForCurrentBreakpoint: function() {
    var breakpoint = this.getCurrentBreakpoint();
    if(this.usedAs() === 'form_confirmation')   {
      return breakpoint.maxPageWidthConfirmation || this.maxDefault;
    } else {
      return breakpoint.maxPageWidth || this.maxDefault;
    }
  },

  getMinWidthForCurrentBreakpoint: function() {
    var breakpoint = this.getCurrentBreakpoint();
    if(this.usedAs() === 'form_confirmation')   {
      return breakpoint.minPageWidthConfirmation || this.minDefault;
    } else {
      return breakpoint.minPageWidth || this.minDefault;
    }
  },

  getBreakPoints: function() {
    return this.breakpoints;
  },

  getEnabledBreakpoints: function () {
    var self = this;
    return this.breakpoints.filter(function (breakpoint) {
      return self.isBreakpointEnabled(breakpoint.name);
    });
  },

  getAppendParamsElementIds: function() {
    return this.elements
      .filter(function(e) {
        return e.model.linksToInternalLightbox() || (e.appendURLParams && e.appendURLParams());
      })
      .filter(function(e) {
        // We don't want to pass params to tel: links
        return e.model.safeGet('action.type') !== 'phone';
      })
      .map(function(e) {
        if (e.type === 'lp-pom-image') {
          return e.id + ' a';
        } else if (e.type === 'lp-pom-text') {
          return e.id + ' a[data-params="true"]';
        } else {
          return e.id;
        }
      });
  },

  _getNewWebFontInsertions: function() {
    var fontScriptContents = fontService.newGenerateFontLoadScriptContent(this);

    if (!_.isEmpty(fontScriptContents)) {
      return {
        content: fontScriptContents,
        placement: 'head'
      };
    }
  },

  _getOldFontInsertions: function() {
    var fonts = this.getFontsFromElements();
    if (fonts.length > 0) {
      return {
        content: fontService.oldGenerateFontLoadScriptContent(fonts),
        placement: 'head'
      };
    }
  },

  getWebFontsInsertion: function() {
    if (ubBanzai.features.isFontPickerEnabled() && !_.isUndefined(this.settings.webFontsInUse)) {
      return this._getNewWebFontInsertions();
    } else {
      return this._getOldFontInsertions();
    }
  },

  removePage: function() {
    var root = this.getRootElement();
    root.view.e.remove();
    root._detach();
    this.fireEvent('pageRemoved');
    this.style.updatePageStyles();
  },

  isInserted: function() {
    return this.pomReady && this.getRootElement().isInserted();
  },

  insertNoRobots: function() {
    var head = document.getElementsByTagName("head")[0];
    var node = document.createElement('meta');
    node.setAttribute('name', 'robots');
    node.setAttribute('content', 'noindex, nofollow');
    head.appendChild(node);
  },

  insertViewportMetaTag: function() {
    var head = document.getElementsByTagName("head")[0];
    var node = document.createElement('meta');
    node.setAttribute('name', 'viewport');
    node.setAttribute('content', 'width=device-width, initial-scale=1.0');
    head.appendChild(node);
  },

  addBreakpoint: function(breakpoint) {
    this.breakpoints.push(breakpoint);
    this.fireEvent('breakpointAdded', breakpoint);
  },

  hasManyBreakpoints: function() {
    return this.breakpoints.length > 1;
  },

  hasBreakpoint: function(name) {
    return typeof this.breakpoints.find( function(breakpoint) {return breakpoint.name === name;}) !== 'undefined';
  },

  switchToBreakpoint: function(name) {
    //Keep track of the undo state because if the undo stack has
    //user changes than we don't want to clear the undo below otherwise
    //we do clear it.
    var clearUndo = !this.undoManager.canUndoOrRedo();
    this.fireEvent('beforeBreakpointChanged', name);

    var breakpoint = this.getBreakpointByName(name);
    if (typeof breakpoint === 'undefined') {
      return;
    }

    this.undoManager.registerUndo({
      action:this.switchToBreakpoint,
      receiver:this,
      params: [this.currentBreakpoint.name]
    });

    this.currentBreakpoint = breakpoint;
    this.updateAndRefresh();
    if(clearUndo) {
      this.undoManager.clearUndoQueue();
    }
    this.fireEvent('breakpointChanged', name);
  },

  updateAndRefresh: function() {
    jQuery(document.activeElement).blur();
    var currentWidth = this.getRootElement().model.get('geometry.contentWidth');
    var maxPageWidth = this.getMaxWidthForCurrentBreakpoint();
    var minPageWidth = this.getMinWidthForCurrentBreakpoint();

    if (currentWidth < minPageWidth) {
      this.getRootElement().model.set('geometry.contentWidth', this.getMinWidthForCurrentBreakpoint());
    } else if (currentWidth > maxPageWidth) {
      this.getRootElement().model.set('geometry.contentWidth', this.getMaxWidthForCurrentBreakpoint());
    }

    this.updateElementGeometry();
    this.updateElementStyles();
    this.fireEvent('pageUpdatedAndRefreshed');
  },

  isDefaultBreakpoint: function(){
    return this.currentBreakpoint.default === true;
  },

  //TODO: Grep for all uses of this and replace with isMobileBreakpoint() or
  //isDesktopBreakpoint()
  getCurrentBreakpoint: function() {
    return this.currentBreakpoint;
  },

  isMobileBreakpoint: function() {
    return this.getCurrentBreakpoint().name === 'mobile';
  },

  isDesktopBreakpoint: function() {
    return this.getCurrentBreakpoint().name === 'desktop';
  },

  getBreakpointByName: function(name) {
    return this.breakpoints.find(function(breakpoint){
      return breakpoint.name === name;
    });
  },

  updateElementStyles: function() {
    this.elements.each(function(elm) {
      if (typeof elm.applyStyleAttributes === 'function') {
        elm.applyStyleAttributes();
      }
    });
    this.getRootElement().applyDefaultStyles();
  },

  updateElementGeometry: function() {
    this.elements.each(function(elm) {
      if (typeof elm.updateElementGeometry === 'function') {
        elm.updateElementGeometry();
      }
    });
    this.getRootElement().applyDefaultStyles();
  },

  getRootElement: function(){
    return this.getElementById('lp-pom-root');
  },

  getElementByIndex: function(index) {
    return this.elements[index];
  },

  getNextElementId: function() {
    this.last_element_id += 1;
    return this.last_element_id;
  },

  removeForm: function() {
    var form = this.getForm();
    if(form) {
      var fromParent = form.getParentElement();
      form.destroy();
      this.has_form = false;
      this.fireEvent('elementRemoved', {element:form, parentElement:fromParent});
    }
  },

  insertElement: function(elm, options){
    this.undoManager.registerUndo({
      action:elm.removeFromPage,
      receiver:elm
    });

    options = options || {};
    elm.id = elm.id || elm.type+"-"+this.getNextElementId();

    if (typeof options.index !== 'undefined' && options.index < this.elements.length) {
      this.elements.splice(options.index, 0, elm);
    } else if (options.container &&
               typeof options.containerIndex !== 'undefined' &&
               options.containerIndex < options.container.childElements.length) {

      var i = this.elements.indexOf(
        options.container.childElements[options.containerIndex]
      );

      this.elements.splice(i, 0, elm);
    } else {
      this.elements.push(elm);
    }

    if (options.container){
      options.container.insertChildElement(elm, options);
    }

    if (elm.type === 'lp-pom-form') {
      this.has_form = true;
      this.style.updatePageStyles();
    }

    if (options.silent){
      return;
    }

    if (options.dontActivateOnInsert) {
     elm.activateOnInsert = false;
    }

    if (options.dontUpdateElementTreeOnInsert) {
     elm.updateElementTreeOnInsert = false;
    }

    this.fireEvent('elementInserted', elm);
  },

  updateElement: function(elm) {
    this.fireEvent('elementInserted', elm);
  },

  removeElement: function(elm, fromParent){
    this.elements = this.elements.without(elm);
    if (elm.type === 'lp-pom-form') {
      this.has_form = false;
    }
    this.fireEvent('elementRemoved', {element:elm, parentElement:fromParent});
  },

  swapElementOrder: function(a,b) {
    var aIndex = this.elements.indexOf(a);
    var bIndex = this.elements.indexOf(b);
    this.elements[aIndex] = b;
    this.elements[bIndex] = a;
  },

  hasForm: function() {
    return this.has_form;
  },

  hasContent: function() {
    return this.getRootElement().childElements.length > 0;
  },

  getDefaultWidth: function() {
    return this.settings.defaultWidth * 1;
  },

  hasLightboxLink: function() {
    return this.isLightbox() && window.editor.hasButtonLinkedTo(this.getRefId());
  },

  isUnlinked: function() {
    return this.isLightbox() && ! this.hasLightboxLink();
  },

  hasBeenViewed: function() {
    return Boolean( ! this.isLightbox() || this.settings.hasBeenViewed);
  },

  markAsViewed: function() {
    this.settings.hasBeenViewed = true;
  },

  CTAifyLink: function(link) {
    return ctaLinkFilter({
      currentUrl: window.location.href,
      enabled: this.getConfigValue('ctaifyLinks'),
      link: link,
      goals: this.goals,
      isPublishMode: this.isPublishMode()
    });
  },

  decorateImageSrc: function(src) {
    return this.isPublishOrPreviewMode() ? '/publish' + src : src;
  },

  getElementCount: function() {
    return this.elements.length;
  },

  getLastElement: function() {
    return this.elements.last();
  },

  getElementTypes: function() {
    return this.elements.pluck('type').uniq();
  },

  getElementById: function(id) {
    var elements = this.elements;
    if(id && id.indexOf('lp-multi-select') > -1) {
      return this._getMultiSelectElement();
    }

    return elements.find(function(e){return e.id === id;});
  },

  getElementByZIndex: function(zIndex) {
    return _.find(this.elements, function(elm) {
      return elm.view && _.isFunction(elm.view.getZIndex) && (elm.view.getZIndex() === zIndex);
    });
  },

  _getMultiSelectElement: function() {
    var activeElement = window.editor.activeElement;
    if(activeElement && activeElement.type === 'lp-multi-select') {
      return activeElement;
    }
  },

  getElementsByType: function(type) {
    return this.elements.select(function(e){return e.type === type;});
  },

  getElementsByTypeList: function(typeArray) {
    return _.flatten(typeArray, function(type){
      return this.getElementsByType(type);
    }, this);
  },

  getParalaxEnabledElements: function() {
    var els = this.getElementsByTypeList(['lp-pom-root', 'lp-pom-block']);
    return _.filter(els, function(el) {
      return el.model.hasParallax();
    });
  },

  isModuleAtLimit: function(module) {
    return this.getElementsByType(module.type).length >= module.getLimit(this);
  },

  getForm: function() {
    return this.getElementsByType('lp-pom-form').first();
  },

  getElementsByTypeAndContainerId: function(type, id){
    return this.elements.select(function(e){return e.containerId === id && e.type === type;});
  },

  indexOfElement: function(elm) {
    return this.elements.indexOf(elm);
  },

  getVisibleElements: function() {
   return this.elements.select(function(e){return e.view;});
  },

  getElementsWithFonts: function() {
    //If the element responds to getFonts return it.
    return this.elements.select(function(e) {
      return typeof e.getFonts === 'function';
    });
  },

  getFontsFromElements: function() {
    var fontList = [];

    this.getElementsWithFonts().each(function(e) {
      fontList.push(e.getFonts());
    });

    return fontList.flatten().sort().uniq(true);
  },

  generateDefaultElementName: function(type, base, copy) {
    copy = copy || false;

    var copyIndex = base.indexOf('copy');
    if (copyIndex > -1) {
      base = base.substr(0, copyIndex-1);
    }

    var withDefaultNames = this.getElementsByType(type)
      .pluck('name').grep(new RegExp('^'+base+(copy ? "\\scopy" : '')+"\\s\\d+"));

    var next;

    if (withDefaultNames.length > 0) {
      next = withDefaultNames.max(function(name) {
        var arr = name.split(' ');
        return arr[arr.length-1] * 1 + 1;
      });
    } else {
      next = 1;
      base = base.sub(/copy\s\d+/, '');
    }

    return base+' '+(copy ? 'copy ' : '')+next;
  },

  hasSections: function() {
    return this.getElementsByType('lp-pom-block').length > 0;
  },

  addInsertion: function(content, placement, insertionOrder) {
    this.insertions.push({
      content: content,
      placement: placement,
      insertionOrder: insertionOrder || this.getHighestPriority()
    });
  },

  getInsertions: function() {
    var sortScriptByOrder = function(scriptA, scriptB) {
      if (scriptA.insertionOrder < scriptB.insertionOrder) {
        return -1;
      } else if (scriptA.insertionOrder > scriptB.insertionOrder) {
        return 1;
      }

      return 0;
    };

    return this.insertions.sort(sortScriptByOrder);
  },

  _getPageDimensionsForJavascriptApi: function() {
    return _.merge(
      this.isDesktopEnabled() ?
        { desktop: this.getDimensions('desktop') } : {},

      this.isMobileEnabled() ?
        { mobile: this.getDimensions('mobile') } : {},

      this.isDesktopEnabled() && this.isMobileEnabled() ?
        { mobileMaxWidth: this.getMobileBreakpointWidth() } : {}
    );
  },

  getUbPageInsertion: function() {
    return {
      content: [
        '<script type="text/javascript">',
        'window.ub = ',
        JSON.stringify({
          page: {
            id: this.uuid,
            variantId: this.variant_id,
            usedAs: this.usedAs(),
            name: gon.page_name,
            url: this.page.published_url,
            dimensions: this._getPageDimensionsForJavascriptApi(),
            isEmbeddable: this.getConfigValue('isEmbeddable') ? true : undefined,
            appendParamsElementIds: this.getAppendParamsElementIds(),
          },
        }),
        ';</script>'
      ].join(''),
      placement: 'head'
    };
  },

  getOpenGraphMetaTagInsertions: function() {
    var pageTitle = this.metaData.title;

    if (_.isEmpty(pageTitle)) {
      pageTitle = this.page.published_url;
    }

    var content = "<meta property='og:title' content='" + _.escape(pageTitle) + "'/>";

    return {
      content: content,
      placement: 'head'
    };
  },

  debugPageInsertions: function() {
    this.getPageInsertions().each(function(i) {
      console.log(i);
    });
  },

  getEmbeddableInsertion: function() {
    if (this.getConfigValue('isEmbeddable')) {
      var displaySettings = this.getRootElement().model.safeGet('displaySettings');
      if (displaySettings) {
        return {
          placement: 'head',
          content: '<script>window.ub.page.embeddableDisplaySettings = ' + JSON.stringify(displaySettings) + ';</script>',
        };
      }
    }
  },

  getJQueryInsertion: function() {
    return {
      content: this.publishedScriptTag('published-js/lp-jquery.bundle.js'),
      placement: 'head',
    };
  },

  getBundledJsInsertion: function() {
    return {
      content: this.hasForm()
        ? this.publishedScriptTag('published-js/with-form.bundle.js', true)
        : this.publishedScriptTag('published-js/without-form.bundle.js', true),
      placement: 'body:after',
    };
  },

  getAsyncCssInsertion: function() {
    // async.css currently only contains styles for forms and the parent page of form confirmation
    // dialogs and lightboxes, so we only insert it if the page has a form or lightbox
    var pageContainsFormOrLightbox = this.hasForm() || this.elements.find(function(element) {
      return element.model.linksToLightbox();
    }) !== undefined;

    if (pageContainsFormOrLightbox) {
      return {
        content: '<noscript id="ub-deferred-styles">' +
          this.publishedStylesheetTag('published-css/async.css') + '</noscript>',
        placement: 'body:after',
      };
    }
  },

  getPageInsertions: function() {
    // TODO-TR: split getPageInsertions out into a separate utils module.
    var insertions = _.compact([].concat(
      this.getPageDefaultsStylesheet(),

      this.getOpenGraphMetaTagInsertions(),

      this.getJQueryInsertion(),
      this.getUbPageInsertion(),
      getLightboxInsertion(this),
      this.getInsertions(),
      this.getWebFontsInsertion(),
      this.getEmbeddableInsertion(),

      this.getBundledJsInsertion(),
      this.getAsyncCssInsertion(),

      getUnsplashTrackingPixel(this)
    ));

    // add html comment markers denoting the start and end of each placement:
    var groupedInsertions = {'head': [], 'body:before':[], 'body:after':[]};
    var addToGroup = function (insertion) {
      groupedInsertions[insertion.placement] = groupedInsertions[insertion.placement] || [];
      groupedInsertions[insertion.placement].push({
        content: insertion.content,
        placement: insertion.placement
      });
    };
    // add all our standard insertions to groupedInsertions:
    insertions.forEach(addToGroup);

    // add comment markers around each 'placement' of insertions:
    var flattenInsertions = function(insertions) {
      var flattenedInsertions = [];
      var add = function (elem) {
          flattenedInsertions.push(elem);
      };
      var startMarker, endMarker;
      for (var placement in insertions) {
        startMarker = 'start';
        endMarker = 'end';
        if (placement.indexOf('before') !== -1) {
          // The lp-publisher code reverses these.
          // It *prepends* elements to the top of body:before.
          startMarker = 'end';
          endMarker = 'start';
        }
        flattenedInsertions.push(
          {placement: placement,
           content: '<!-- lp:insertions ' + startMarker + ' ' + placement + ' -->'});
        insertions[placement].forEach(add);
        flattenedInsertions.push(
          {placement: placement,
           content: '<!-- lp:insertions ' + endMarker + ' ' + placement + ' -->'});
      }
      return flattenedInsertions;
    };
    //
    return flattenInsertions(groupedInsertions);
  },

  topMost: function(elm1, elm2) {
    //TODO: refactor
    /*jshint maxcomplexity: 15 */
    if (elm1.page !== elm2.page || elm1.parentElement === null || elm2.parentElement === null) {
      return;
    }

    var e1 = elm1;
    var e2 = elm2;
    var d1 = elm1.getRootDistance();
    var d2 = elm2.getRootDistance();

    if (d1 < d2) {
      e2 = elm2.getAncestorAtDistance(d1);
      if (e2 === e1 || d1 < 2) {
        return elm2;
      }
    } else if (d2 < d1) {
      e1 = elm1.getAncestorAtDistance(d2);
      if (e2 === e1 || d2 < 2) {
        return elm1;
      }
    }

    var z1 = e1.model.getZIndex() || 0;
    var z2 = e2.model.getZIndex() || 0;

    if (z1 > z2) {
      return elm1;
    }

    if (z2 > z1) {
      return elm2;
    }

    var i1 = this.elements.indexOf(e1);
    var i2 = this.elements.indexOf(e2);

    return (i1 > i2) ? elm1 : elm2;
  },

  getPageDefaultsStylesheet: function() {
    return {
      content: this.publishedStylesheetTag('published-css/page-defaults.css'),
      placement: 'head'
    };
  },

  getAttachments: function() {
    var attachments = [];
    this.getElementsByType("lp-pom-button").each( function(b) {
      if (b.model.exists("action") && b.model.get("action.type") === "download") {
        attachments.push(b.model.get("action.asset"));
      }
    });
    return attachments;
  },

  getDimensions: function(breakpointName) {
    var breakpoint = this.getBreakpointByName(breakpointName);
    var rootElement = this.getRootElement();

    var totals = rootElement.getSections()
      .filter(function(section) {
        return section.model.isVisible(breakpointName);
      })
      .reduce(function(acc, section) {
        var model = section.model;

        var hasOutsideBorder =
          model.safeGet('style.border.style', breakpoint) !== 'none' &&
          model.safeGet('geometry.borderLocation', breakpoint) === 'outside';

        var borderSize = hasOutsideBorder ? model.safeGet('style.border.width', breakpoint) || 0 : 0;

        return {
          height:
            acc.height +
            model.getHeight(breakpoint) +
            (model.safeGet('geometry.margin.bottom', breakpoint) || 0) +
            (model.safeGet('geometry.borderApply.top', breakpoint) ? borderSize : 0) +
            (model.safeGet('geometry.borderApply.bottom', breakpoint) ? borderSize : 0),
          leftBorder: Math.max(
            acc.leftBorder,
            model.safeGet('geometry.borderApply.left', breakpoint) ? borderSize : 0
          ),
          rightBorder: Math.max(
            acc.rightBorder,
            model.safeGet('geometry.borderApply.right', breakpoint) ? borderSize : 0
          ),
        };
      }, {
        height: rootElement.model.safeGet('geometry.padding.top', breakpoint) || 0,
        leftBorder: 0,
        rightBorder: 0,
      });

    return {
      height: totals.height,
      width: rootElement.model.get('geometry.contentWidth', breakpoint) +
        totals.leftBorder + totals.rightBorder,
    };
  },

  getContentWidth: function() {
    return this.getRootElement().getContentWidth();
  },

  usedAs: function() {
    return this.page.used_as;
  },

  isMain: function() {
    return this.usedAs() === 'main';
  },

  isLightbox: function() {
    return this.usedAs() === 'lightbox';
  },

  isFormConfirmation: function() {
    return this.usedAs() === 'form_confirmation';
  },

  getUsedAsText: function() {
    if (_.isUndefined(this.page) || this.isMain()) {
      return this.getConfigValue('displayName');
    } else if (this.isFormConfirmation()) {
      return 'Form Confirmation Dialog';
    } else if (this.name) { // e.g. lightboxes
      return this.name;
    } else {
      return 'Page';
    }
  },

  allowForm: function() {
    return this.isMain() || this.isLightbox();
  },

  allowTitleAndMetadata: function() {
    return this.isMain() && this.getConfigValue('allowPageMetadata');
  },

  allowRootBackground: function() {
    return this.isMain() && this.getConfigValue('allowRootBackground');
  },

  allowParallax: function() {
    // Parallax shouldn't be allowed on form confirmation dialogs but we're leaving it
    // there for legacy reasons
    return this.isDesktopBreakpoint() &&
      ! window.editor.page.isLightbox() &&
      this.getConfigValue('allowParallaxBackgrounds');
  },

  allowAutoLayout: function() {
    return this.isMobileBreakpoint() && this.getConfigValue('allowAutoLayout');
  },

  allowFitWidthToPage: function() {
    return this.isMain() && this.getConfigValue('allowFitWidthToPage');
  },

  allowSectionMargins: function() {
    return this.isMain() && this.getConfigValue('allowSectionMargins');
  },

  allowTopPadding: function() {
    return this.isMain() && this.getConfigValue('allowRootTopPadding');
  },

  allowExternalLightboxes: function() {
    return this.getConfigValue('allowExternalLightboxes') &&
      ubBanzai.features.isExternalLightboxesEnabled();
  },

  toFullJSO: function() {
    var jso = {
      description: this.metaData.description,
      elements: _.map(this.elements, function(elm) {
        return elm.toJSO();
      }),
      goal_type:null,
      goal_url:null,
      has_form:this.hasForm(),
      id: this.id,
      keywords: this.metaData.keywords,
      last_element_id:this.last_element_id,
      name: this.name,
      page: this.page,
      settings: this.settings,
      shared: this.shared,
      styles: this.styles,
      title: this.metaData.title,
      type: 'PageVariant', // Saving as anything other than 'PageVariant' breaks saving to webapp
      variant_id: this.variant_id,
      version: this.version,
    };

    return jso;
  },

  toJSO: function() {
    var cta = this.cta;
    if (cta === '' || cta === null) {
      var urls = this.getURLs('link');
      if (urls.length > 0) {
        cta = urls[0];
      }
    }

    var jso = {
      version: this.version,
      name: this.name,
      shared: this.shared,
      last_element_id:this.last_element_id,
      goal_url:null,
      goal_type:null,
      has_form:this.hasForm(),
      title: this.metaData.title,
      description: this.metaData.description,
      keywords: this.metaData.keywords,
      settings: this.settings,
      styles: this.styles,
      elements:[]
    };

    this.elements.each(function(e){
      jso.elements.push(e.toJSO());
    });

    return jso;
  },

  prepareForSave: function(editor) {
    if (ubBanzai.features.isFontPickerEnabled()) {
      fontService.storeTextWebFontsInUse(this);
    }

    var allowAbsolutePositionFields = this.getConfigValue('allowFormColumns') &&
      ubBanzai.features.isAllowFormColumnsEnabled() &&
      ubBanzai.features.isAbsolutePositionFieldsEnabled();

    if (allowAbsolutePositionFields) {
      formPublishStyles.saveStylesForPublish(this, this.elements, editor);
    }

    this.fireEvent('beforePageSave', this.page);
  },

  toXML: function() {
    var elements = [];
    var attachments = this.getAttachments();

    this.elements.each(function(e){
      elements.push(e.toJSO());
    });

    /* jshint multistr:true */
    var xml = '<'+this.resourceType.underscore()+'>'+
        (Object.isUndefined(this.page) ?
        '' :
        '<page> \
          <id>'+this.page.id+'</id> \
          <name>'+this.page.name+'</name> \
          <used_as>'+this.page.used_as+'</used_as>'+
          (Object.isUndefined(this.page.path_name) ? '' : '<path_name>'+this.page.path_name+'</path_name>')+
        '</page>')+
        '<id>'+this.id+'</id> \
         <version>'+this.version+'</version> \
         <name><![CDATA['+this.name+']]></name> \
         <last_element_id>'+this.last_element_id+'</last_element_id> \
         <has_form>'+this.has_form+'</has_form> \
         <title><![CDATA['+this.metaData.title+']]></title> \
         <description><![CDATA['+this.metaData.description+']]></description> \
         <keywords><![CDATA['+this.metaData.keywords+']]></keywords> \
         <settings><![CDATA['+Object.toJSON(this.settings)+']]></settings> \
         <elements><![CDATA['+Object.toJSON(elements).gsub(']]>',']]]]><![CDATA[>')+']]></elements>';

                  // <styles><![CDATA['+this.styles.toJSON()+']]></styles> \

    if (attachments.length > 0) {
      attachments.each( function(a) {
        xml += '<add_attachment> \
                <asset_id>'+a.id+'</asset_id> \
                <protected_download>'+a.protected_download+'</protected_download> \
                </add_attachment>';
      });
    }

    xml += '</'+this.resourceType.underscore()+'>';

    return xml;
  },

  publishedStylesheetTag: function(path, id) {
    var params = id ? 'id="' + id + '"' : '';
    return '<link href="' + window.lp.getPublishedAssetsUrl(path) +
      '" rel="stylesheet" media="screen" type="text/css" ' + params + '/>';
  },

  publishedScriptTag: function(path, async) {
    return '<script ' + (async ? 'async ' : '') + 'src="' + window.lp.getPublishedAssetsUrl(path) +
      '" type="text/javascript"></script>';
  },

  getConfigValue: function(property) {
    return contentTypeConfig.getValue(property, this.settings.contentType);
  },

  getLastTextStyle: function() {
    return this.settings.lastTextStyle || null;
  },

  setLastTextStyle: function(textStyleObject) {
    if (_.isEmpty(textStyleObject)) {
      delete this.settings.lastTextStyle;
    } else {
      this.settings.lastTextStyle = textStyleObject;
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/pom/page.js
// module id = 448
// module chunks = 0 1